import api from '@/services/api';

const BASE_URL = '/time-tracking';

export default {
  lastClockIn({ clinicId }) {
    const queryStr = `clinicId=${clinicId}`;
    return api.get(`${BASE_URL}/last-clock-in?${queryStr}`);
  },
  clockIn(payload) {
    return api.post(`${BASE_URL}/clock-in`, payload);
  },
  clockOut(payload) {
    return api.post(`${BASE_URL}/clock-out`, payload);
  },
};
